/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ApiFrontendHomepageServiceTypesListLocationType =
  (typeof ApiFrontendHomepageServiceTypesListLocationType)[keyof typeof ApiFrontendHomepageServiceTypesListLocationType];

export const ApiFrontendHomepageServiceTypesListLocationType = {
  address: 'address',
  adwords: 'adwords',
  'bounding-box': 'bounding-box',
  city: 'city',
  country: 'country',
  county: 'county',
  'current-location': 'current-location',
  geoip: 'geoip',
  neighborhood: 'neighborhood',
  other: 'other',
  state: 'state',
  'zip-code': 'zip-code',
} as const;
